//@ts-ignore
import NonBSP from "./NonBSP";

export default NonBSP;
